import {
    Collapse,
    UncontrolledCollapse,
    Button,
    CardBody,
    Card,
} from "reactstrap";
import Lazyload from "react-lazy-load";
import Testimonials from "./TestimonialsHome";
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const RemoteTeamWellness = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero rt-1">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h1 className="font-weight-semibold hero-heading text-center no-br">
                            <Trans>Unlock Wellness <br/>for Remote Teams</Trans>
                        </h1>
                        <p className="hero-para font-weight-normal text-center no-br">
                            <Trans>Address the unique wellness challenges <br/>of remote workforces effectively.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative pb-0 vfitsoln">
                <div className="dark-bg">
                    <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p0">
                        <div className="col-12 text-center section-pdn-1">
                            <div className="col-12 p-0">
                                <h2 className="font-weight-semibold py-2 section-heading mb-4 no-br">
                                    <Trans>Struggling to maintain wellness <br/>routines for your remote teams?</Trans>
                                </h2>
                                <p className="section-para font-weight-normal no-br">
                                <Trans>Our remote team wellness solutions are designed to bridge the gap, <br/>ensuring your employees stay healthy, no matter where they are.</Trans>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="m030">
                        <img
                            className="img-responsive mx-auto"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699959304/VantageFit/2023/Remote_Team_Wellness-painpoint.webp"
                            width="1119"
                            height="600"
                            alt="Struggling to maintain wellness routines for your remote teams?"
                        />
                        {/* https://res.cloudinary.com/vantagecircle/image/upload/v1696834120/VantageFit/2023/team-challenge-track.png */}
                    </div>
                </div>
            </section>

            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br">
                    <Trans>Empowering Remote Team Health</Trans>
                    </h2>
                    <div className="">
                        <div className="feat_box sect-white-col-2 shadow active_challenge">
                            <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                                <div className="col-12 col-md-5">
                                    <div className="col-12">
                                        <h2 className="font-weight-semibold py-2 section-heading">
                                        <Trans>Flexible Scheduling</Trans>
                                        </h2>
                                        {/* <p className='section-para font-weight-normal'>Wellness challenges and sessions tailored to fit various time zones and work routines.</p> */}
                                        <div className="col-12">
                                            {/* <h2 className='font-weight-semibold py-2 section-heading'>Push Each Other to Work Harder</h2> */}
                                            {/* <p className='section-para font-weight-normal'>Set collective milestones and watch your teams work together to achieve them.</p> */}
                                            <div>
                                                <ul
                                                    className="greenTick position-relative"
                                                    style={{
                                                        minHeight: "29px",
                                                        marginTop: "2.5rem",
                                                        marginBottom: "2.5rem",
                                                    }}
                                                >
                                                    <p className="text-white">
                                                    <Trans>Enable the
                                                        personalization of
                                                        wellness challenges and
                                                        sessions to accommodate
                                                        diverse time zones.</Trans>
                                                    </p>
                                                </ul>
                                                <ul
                                                    className="greenTick position-relative"
                                                    style={{
                                                        minHeight: "29px",
                                                        marginTop: "2.5rem",
                                                        marginBottom: "2.5rem",
                                                    }}
                                                >
                                                    <p className="text-white">
                                                        <Trans>Tailor activities to
                                                        suit different work
                                                        schedules.</Trans>
                                                    </p>
                                                </ul>
                                                <ul
                                                    className="greenTick position-relative"
                                                    style={{
                                                        minHeight: "29px",
                                                        marginTop: "2.5rem",
                                                        marginBottom: "2.5rem",
                                                    }}
                                                >
                                                    <p className="text-white">
                                                        <Trans>Ensure wellness
                                                        initiatives seamlessly
                                                        integrate into various
                                                        daily routines.</Trans>
                                                    </p>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 cta-img">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699959301/VantageFit/2023/Remote_Team_Wellness-Flexible_Scheduling.webp"
                                            loading="lazy"
                                            alt="Flexible Scheduling"
                                            width="415"
                                            height="600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="feat_box sect-white-col-2 shadow active_challenge">
                            <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                                <div className="col-12 col-md-5">
                                    <div className="col-12">
                                        <h2 className="font-weight-semibold py-2 section-heading">
                                            <Trans>Virtual Group Activities</Trans>
                                        </h2>
                                        {/* <p className='section-para font-weight-normal'>Yoga, meditation and fitness classes designed for virtual participation.</p> */}
                                        <div>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                    <Trans>Virtual yoga, meditation,
                                                    and fitness classes tailored
                                                    for remote participation.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                    <Trans>Drive engagement in group
                                                    activities seamlessly
                                                    through virtual platforms.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                    <Trans>Foster a sense of community
                                                    and well-being through
                                                    virtual interactions.</Trans>
                                                </p>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 cta-img">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            className="img-responsive"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699959302/VantageFit/2023/Remote_Team_Wellness-Virtual_Group_Activities.webp"
                                            loading="lazy"
                                            alt="Virtual Group Activities"
                                            width="574"
                                            height="600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="feat_box sect-white-col-2 shadow active_challenge">
                            <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                                <div className="col-12 col-md-5">
                                    <div className="col-12">
                                        <h2 className="font-weight-semibold py-2 section-heading">
                                            <Trans>Rewards & Recognition</Trans>
                                        </h2>
                                        {/* <p className='section-para font-weight-normal'>Honor milestones and efforts to enhance motivation with our Vantage Fit points.</p> */}
                                        <div>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                    <Trans>Recognize achievements and
                                                    efforts through Vantage Fit
                                                    points.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                <Trans>Enhance motivation by
                                                    honoring milestones with
                                                    tangible benefits.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                <Trans>Use Vantage Fit points to
                                                    incentivize and acknowledge
                                                    individual and team
                                                    achievements.</Trans>
                                                </p>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 cta-img">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            className="img-responsive"
                                            src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703069789/VantageFit/2023/Remote_Team_Wellness-Rewards_Recognition.webp`)}
                                            loading="lazy"
                                            alt="Rewards & Recognition"
                                            width="519"
                                            heigth="600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="feat_box sect-white-col-2 shadow active_challenge">
                            <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                                <div className="col-12 col-md-5">
                                    <div className="col-12">
                                        <h2 className="font-weight-semibold py-2 section-heading">
                                        <Trans>Mental Well-being Resources</Trans>
                                        </h2>
                                        {/* <p className='section-para font-weight-normal'>Articles, webinars and support tailored for the unique stresses of remote work.</p> */}
                                        <div>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                <Trans>Empower your employees with a range of mental well-being resources.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                <Trans>Equip your workforce with resources specifically aimed at tackling mental health challenges in the context of remote work.</Trans>
                                                </p>
                                            </ul>
                                            <ul
                                                className="greenTick position-relative"
                                                style={{
                                                    minHeight: "29px",
                                                    marginTop: "2.5rem",
                                                    marginBottom: "2.5rem",
                                                }}
                                            >
                                                <p className="text-white">
                                                <Trans>Empower your employees to choose their preferred format for accessing mental well-being resources, be it podcasts, videos, or articles.</Trans>
                                                </p>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-7 cta-img">
                                    <div className="d-flex justify-content-center">
                                        <img
                                            className="img-responsive"
                                            src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703069787/VantageFit/2023/Remote_Team_Wellness-Mental_Well-being_Resources.webp`)}
                                            loading="lazy"
                                            alt="Mental Well-being Resources"
                                            width="549"
                                            height="600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="gray-gradient-bg section-pdn-1">
                <div className="container custom_container mx-auto relative">
                    <div className="px-5">
                        <h2 className="section-heading text-center pt-0">
                        <Trans>Real people, real results</Trans>
                        </h2>
                        <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                        <Trans>Vantage Fit speaks for itself, but our customer
                            reviews speak even louder.</Trans>
                        </p>
                        <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                            <div className="testi_profile">
                                <div className="testi_profile_image">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/elsa_Robertson.webp"
                                        alt="Elsa Robertson"
                                        className="max-w lozad"
                                        width="218"
                                        height="218"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="testi_profile_name p-4">
                                    <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">
                                    Elsa Robertson
                                    </h3>
                                    <p className="font-weight-light text-center text-lg-left text-white mb-0">
                                    <Trans>Senior Associate at Heidrick & Struggles, Australia</Trans>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                                <div className="col-12 col-md-11 d-flex flex-column">
                                    <p className="section-para text-center text-lg-left mb-0">
                                    <Trans>The <span>Vantage Fit</span> app is an
                                        effective tool for corporate walking
                                        challenges, offering a range of features
                                        to help participants stay motivated and
                                        connected throughout the challenge.</Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className="d-md-none d-block p-3"
                            style={{
                                background: "white",
                                boxShadow: "1px 0px 20px rgba(0,0,0,0.3)",
                                borderRadius: "25px",
                            }}
                        >
                            <div
                                className="p-2"
                                style={{
                                    background: "#1d2227",
                                    borderRadius: "40px",
                                    display: 'grid',
                                    justifyContent: 'center'
                                }}
                            >
                                <img
                                    style={{
                                        marginLeft: "0.5rem !important",
                                        marginTop: "0.5rem",
                                        marginBottom: "1rem",
                                    }}
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/elsa_Robertson.webp"
                                    alt="Elsa Robertson"
                                    className="mx-auto"
                                    width="218"
                                    height="218"
                                    loading="lazy"
                                />
                                <h3 className="font-weight-bold text-center text-white mb-0">
                                    Elsa Robertson
                                </h3>
                                <p className="font-weight-light text-center text-white my-3">
                                <Trans>Senior Associate at Heidrick & Struggles, Australia</Trans>
                                </p>
                            </div>
                            <p className="section-para text-center text-lg-left my-4">
                            <Trans>The <span>Vantage Fit</span> app is an effective
                                tool for corporate walking challenges, offering
                                a range of features to help participants stay
                                motivated and connected throughout the
                                challenge.</Trans>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative section-pdn-1 pl-0 pr-0">
                <div className="logo-container">
                    <h2 className="section-heading mb-5 no-br clr50">FAQ</h2>
                    <div id="accordion" className="">
                        <Card>
                            <Button id="faq1">
                            <Trans>How do you cater to different time zones?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq1">
                                <CardBody>
                                <Trans>Vantage Fit caters to different time zones
                                    by scheduling live fitness sessions and
                                    challenges accessible at various times,
                                    offering on-demand webinar sessions, and
                                    providing flexibility for users to set their
                                    own challenge start times. Challenges in
                                    Vantage Fit are strategically scheduled to
                                    accommodate users from different time zones,
                                    ensuring accessibility to all live
                                    challenges regardless of their geographical
                                    location.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq2">
                            <Trans>Can we integrate our own virtual fitness
                                instructors?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq2">
                                <CardBody>
                                <Trans>Currently, Vantage Fit does not offer this
                                    feature within its app, but it is a
                                    potential enhancement that may be enabled in
                                    the future.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                        <Card>
                            <Button id="faq3">
                            <Trans>What tech requirements are needed for remote
                                employees to participate?</Trans>
                            </Button>
                            <UncontrolledCollapse toggler="#faq3">
                                <CardBody>
                                <Trans>Vantage Fit keeps an easy process for remote
                                    employees to participate in Vantage Fit.
                                    Basic tech requirements include a stable
                                    internet connection, a compatible device
                                    (smartphone, tablet, or computer), and the
                                    ability to access our platform through a web
                                    browser or our mobile app.</Trans>
                                </CardBody>
                            </UncontrolledCollapse>
                        </Card>
                    </div>
                </div>
            </section>

            <section className="rt-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center">
                        <Trans>Ready to Revolutionize Remote Team Wellness?</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5">
                        <Trans>Discover the Vantage Fit difference today.</Trans>
                        </p>
                        <div className="pl-0 pr-0 col-12 mt-4 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default RemoteTeamWellness;
